export const ITEMS_PER_PAGE = 10;

export const LOT_STATUS_OPTIONS = [
  { value: 'no_disponible', label: 'No disponible' },
  { value: 'disponible', label: 'Disponible' },
  { value: 'vinculado', label: 'Vinculado' },
];

export const PERSON_NAME_OPTIONS = [
  { value: 'Marcelo Von Der Heyde', label: 'Marcelo Von Der Heyde' },
  { value: 'Guillermo Von Der Heyde', label: 'Guillermo Von Der Heyde' },
  { value: 'Maria Lucrecia Von Der Heyde', label: 'Maria Lucrecia Von Der Heyde' },
  { value: 'Florencia Von Der Heyde', label: 'Florencia Von Der Heyde' },
  { value: 'Constructora Colonial', label: 'Constructora Colonial' },
];

export const INITIAL_LOT_STATE = {
  uuid_allotment: '',
  uuid_contract: '',
  uuid_construction_type: '',
  lot_number: '',
  block_number: '',
  cadastral_number: '',
  surface_area: '',
  estimated_delivery_date: '',
  status: 'disponible',
  person_name: '',
  pos_x: 50,
  pos_y: 50,
};
